import type { EnhancedProductFamilyId, EnhancedProductGroupId, EnhancedProductVariantId } from '#api/enhancements/enhancedTmsApiTypes'
import type { Brand } from '#types/Brand'

export type FavoriteEntryId = EnhancedProductFamilyId | EnhancedProductGroupId | `${EnhancedProductFamilyId}${EnhancedProductVariantId}`

export type FavoriteEntry = {
  id: EnhancedProductFamilyId | EnhancedProductGroupId | `${EnhancedProductFamilyId}${EnhancedProductVariantId}`
  createdAt: Timestamp
}

export type FavoriteSetId = Brand<string, '__favoriteSetId'>

export type FavoriteSet = {
  id: FavoriteSetId
  name: string
  createdAt: Timestamp
  entries: FavoriteEntry[]
}

export type NewFavoriteSet = Omit<FavoriteSet, 'id' | 'createdAt' | 'entries'> & Partial<Pick<FavoriteSet, 'entries' | 'id'>>
export type UpdateFavoriteSet = { id: FavoriteSetId } & Partial<Omit<FavoriteSet, 'id' | 'createdAt' | 'entries'>>

export type FavoriteSets = FavoriteSet[]

export const defaultFavoriteSetId: FavoriteSetId = 'default' as FavoriteSetId
